module.exports = __webpack_public_path__ + "static/media/high-rise-buildings-1907046.dfe8baee.jpg";